import './ListView.css';

export default function ListView({ list }) {
  return (
    <div className='listView'>
      {list?.map((li) => (
        <ul key={li.id}>
          <li>{li.title}</li>
        </ul>
      ))}
    </div>
  );
}
